{
  "message": "francais",
  "mytext": "Au revoir",
  "Colon": " :",
  "SeeMore": "Voir plus >",
  "Notification": "Nouveau",
  "ProfileTitle": "Mon profil",
  "NextButton": "Suivant",
  "PrintButton": "Imprimer",
  "PreviousButton": "Retour",
  "Reset": "Réinitialiser",

  "Yes": "Oui",
  "No": "Non",

  "Default Title": "Title",
  "Default Subtitle": "Subtitle",

  "And": "et",
  "Or": "ou",

  "Search": "Recherche",
  "SearchResults": "Résultats de la recherche",

  "Error": "Erreur",

  "Send": "Envoyer",
  "Refresh": "Rafraîchir",

  "Confirmation": "Attention",

  "Profile": {
    "Title": "Mon profil",
    "Username": "Nom d'utilisateur",
    "Email": "Email",
    "Role": "Rôle",
    "Confirmed": "Confirmé",
    "CreationDate": "Date de création"
  },

  "Status": {
    "new": "Nouveau",
    "accepted": "Accepté",
    "ready": "Prêt",
    "proposed": "Proposé",
    "scheduled": "Planifié",
    "completed": "Terminé"
  },

  "Disclaimer": {
    "Title": "Disclaimer",
    "TextShort": "B. Braun Medical SA n’assume aucune garantie concernant l’exactitude, l’intégralité ou l’actualité du contenu de „pharmacists.bbraun.ch“.",
    "Text": "<p><b>Conditions d'utilisation</b> Les informations, indications et données contenues sur le site Internet \"pharmacists.bbraun.ch\" concernant les produits de B. Braun Medical SA, en particulier les solutions pour perfusion et leur utilisation, servent exclusivement et uniquement à informer les pharmaciens hospitaliers des hôpitaux suisses qui utilisent ces médicaments dans leur établissement. L'accès à ces informations, indications et données est accordé aux pharmaciens hospitaliers qui se sont préalablement enregistrés avec leurs données personnelles dans le but d'accéder à ces informations et qui ont reçu, après vérification des données par l'exploitant, un mot de passe leur permettant d'accéder aux contenus du site Internet. En accédant au site web, l'utilisateur déclare accepter les conditions d'utilisation et l'exclusion de responsabilité ci-après. <br/><b>Clause de non-responsabilité</b> B. Braun Medical SA a élaboré les informations, indications et données mises à disposition sur le site Internet avec le soin requis, mais ne garantit pas que les informations, indications et données mises à disposition soient toujours actuelles, correctes, complètes ou de bonne qualité. Dans la mesure où la loi l'autorise, B. Braun Medical SA exclut toute responsabilité pour elle-même et pour les collaborateurs impliqués en cas de dommages de toute nature, de dommages corporels ou matériels, de dommages directs ou indirects pouvant résulter de l'accès aux informations ou en rapport avec l'accès aux informations, l'utilisation des informations mises à disposition ou la consultation des informations. L'exclusion de responsabilité comprend également la responsabilité pour le fonctionnement sans faille du site web, notamment en raison de défauts techniques, et la responsabilité pour les dommages résultant d'erreurs de transmission, de défauts techniques, de perturbations ou d'interruptions de l'accès à Internet, d'interventions illégales dans les installations de télécommunication, de l'introduction de virus, de la copie et de la falsification de contenus, de surcharges du réseau, de la non-reconnaissance de contrefaçons, de défauts de légitimation, de blocages volontaires ou accidentels d'accès électroniques par des tiers. L'exclusion de responsabilité comprend également la responsabilité pour les dommages subis par l'utilisateur (ou le client) du fait de l'inexécution d'obligations contractuelles, ainsi que pour les dommages indirects et les dommages consécutifs, tels que le manque à gagner ou les prétentions de tiers. B. Braun Medical SA se réserve le droit de modifier à tout moment tout ou partie des informations mises à disposition, notamment de les adapter aux évolutions techniques ou juridiques, de les compléter, de les supprimer ou d'en suspendre temporairement ou définitivement la publication. <br/><b>Droit applicable/juridiction compétente</b> L'ensemble du site Internet, les conditions d'utilisation et la clause de non-responsabilité sont exclusivement régis par le droit suisse. Tous les litiges relatifs à ces conditions sont soumis à la juridiction des tribunaux compétents du siège de B. Braun Medical SA. </p>"
  },

  "Infusion": {
    "InContainer": {
      "Title": "Dans un contenant",
      "Text": "La compatibilité physico-chimique de la solution de perfusion est testée après l'ajout du médicament.",
      "MoreText": "La compatibilité physico-chimique de Ringerfundin® a été testée pendant 24 heures à température ambiante après l'ajout des  médicaments i.v. suivants."
    },
    "InLine": {
      "Title": "Dans une tubulure",
      "Text": "La compatibilité physico-chimique des mélanges de solution de perfusion avec les médicaments est testée proportionnellement à leur débit de perfusion.",
      "MoreText":"La compatibilité physico-chimique des mélanges de la solution pour perfusion X® avec les médicaments i.v. suivants a été testée en fonction de leurs vitesses de perfusion, directement après mélange (4 minutes) et après 60 minutes de contact :"
    }
  },

  "Requests": {
    "TestPlan": "Plan de test",
    "CreationDate": "Date de création",
    "EditedDate": "Date de modification",
    "SendQuestion": "Envoyer une question",
    "SendResponse": "Envoyer une réponse",
    "FileRejectedForGivenReason": "Le fichier a été rejeté pour la raison suivante:",
    "FileNotFound": "Le fichier n'a pas été trouvé",
    "SendPrufplan": "Envoyer un pré-plan",
    "PrufplanSent": "Le pré-plan a été envoyé",
    "SelectPrufplan": "Sélectionner un pré-plan",
    "NewDocument": "Nouveau document",
    "InputPlaceholder": "Entrez votre message",
    "RejectRequest": "Rejeter la demande",
    "CreatePlan": "Créer un plan",
    "CreatePlans": "Créer des plans",
    "ChooseMeds": "Choisir des médicaments",
    "ChooseMedsSubtitle": "Choisissez pour lesquels des médicaments suivants vous souhaitez créer un plan de test (chaque médicament selectionné créera un test associé)",
    "Questions": "Clarifications / Questions Ecotox",
    "AutomatedAnswer": "Réponse automatique",
    "ClickToSeePdf": "Cliquez pour voir le PDF",
    "TestPlanPropositionDocument": "Proposition de tests (PDF)",
    "ProjectNumber": "Numéro de projet",
    "Revision": "Révision",
    "Revisions": "Révisions",
    "Status": "Statut",
    "TestedPreparation": "Préparation testée",
    "Preparation": "Préparation",
    "DrugSolutionConcentration": "Concentration de la solution médicamenteuse",
    "PerfusionRate": "Vitesse de perfusion",
    "Combination": "Combinaison",
    "PreparationCompatibility": "Compatibilité de la préparation",
    "NoRequestAtThisStep": "Aucune demande à ce stade",
    "OtherTabsRequests": "Demandes à d'autres étapes",
    "SelectedFile": "Fichier sélectionné",
    "SaveDraft": "Enregistrer le brouillon",
    "Saved": "Enregistré",
    "AddCompatibility": "Ajouter une compatibilité",
    "SendTestReport": "Envoyer le rapport de test",
    "UploadTestReport": "Uploader le rapport de test",
    "ChooseFile": "Choisir un fichier",
    "DocumentName": "Nom du document",
    "DocumentSize": "Taille du document",
    "PublicationDate": "Date de publication",
    "PublishCompatibility": "Publier la compatibilité",
    "ValidatePlan": "En cliquant sur \"oui\", vous confirmez la publication de la compatibilité proposée.",
    "ThisActionCannotBeUndone": "Cette action ne peut pas être annulée."
  },

  "Header": {
    "FirstNavBar": {
      "HomeButton": "Accueil",
      "LogoutButton": "Se déconnecter",
      "ContactButton": "Contact"
    },
    "SecondNavBar": {
      "ProdukteUndTherapienButton": "PRODUITS ET THÉRAPIES",
      "StoriesButton": "STORIES",
      "Companies": "ENTREPRISE",
      "SearchPlaceholder": "Recherche"
    }
  },
  "Footer": {
    "FooterNav": {
      "LegalNotice": "Mentions légales",
      "TermsOfUse": "Conditions d'utilisation",
      "Privacy": "Protection des données",
      "GeneralTerms": "Conditions générales"
    }
  },
  "Home": {
    "Title": "Pharmacists",
    "Subtitle": "Portail d'information",
    "ShowButton": "Afficher",
    "CompatibilityData": {
      "Title": "Données sur la compatibilité",
      "Description": "Les durées de compatibilité énumérées ici font référence à la compatibilité physico-chimique telle que le changement de pH, le changement de couleur, la turbidité, le changement de taille des particules ou la précipitation. Les données ne fournissent pas d'informations concernant la pharmacocinétique et la pharmacodynamique. Les mélanges indiqués ne constituent pas des recommandations de dosage."
    },
    "OsmolarityCalculator": {
      "Title": "Calculateur d'osmolarité",
      "Description": "Le calculateur vous permet d'obtenir facilement l'osmolarité d'une solution de perfusion avec ajout d'additifs perfusables."
    },
    "ProductInformation": {
      "Title": "Informations produit",
      "Description": "B. Braun propose des produits et des solutions pour le traitement par perfusion."
    },
    "FAQ": {
      "Title": "FAQ",
      "Description": "Vous trouverez ici une compilation de questions/réponses importantes sur différents sujets liés au traitement par perfusion et à la nutrition parentérale."
    },
    "News": {
      "Title": "Actualités",
      "NoNews": "Aucune actualité pour le moment"
    }
  },
  "Faq": {
    "Title": "FAQ's",
    "Subtitle": "Frequently Asked Questions",
    "Help":"Comment pouvons-nous vous aider ?"
  },
  "Login": {
    "PresentationSection": {
      "Title": "Informations pour le pharmacien hospitalier",
      "Resume": "Avec le site Internet «pharmacists.bbraun.ch», B. Braun Medical SA met à votre disposition un portail d’information dont l’accès vous est réservé en tant que pharmacien hospitalier."
    },
    "LoginSection": {
      "Title": "Connexion",
      "P1": "Le site internet “pharmacists.bbraun.ch” fournit les services suivants:",
      "P2": "Données actuelles sur la compatibilité physico-chimique de nos produits",
      "P3": "Calculateur d’osmolarité, permettant de calculer l’osmolarité de solutions de perfusion avec ajout d’additifs perfusables",
      "P4": "FAQ donnant les réponses aux questions fréquemment posées sur le traitement par perfusion",
      "DataPrivacyCheckbox": "Par la présente, je confirme avoir pris connaissance de la %LINK%.",
      "DataPrivacyLink": "Déclaration de confidentialité",
      "EmailUsername":"Adresse mail/nom d'utilisateur",
      "Password":"Mot de passe",
      "RepeatPassword":"Confirmer le mot de passe",
      "ForgotPassword":"Mot de passe oublié",
      "RegisterNow":"Se connecter",
      "ToRegister":"Créer un compte",
      "ConfirmationSent":"Un email de confirmation vous a été envoyé",
      "AlreadyRegistered":"Déjà inscrit ?",
      "OldPassword":"Ancien mot de passe",
      "NewPassword":"Nouveau mot de passe",
      "ConfirmNewPassword":"Confirmer le nouveau mot de passe",
      "ResetPassword":"Réinitialiser le mot de passe"
    },
    "ErrorHandling": {
      "EmptyFields":"Veuillez remplir tous les champs",
      "InvalidCredentials":"Nom d'utilisateur ou mot de passe incorrect",
      "PasswordRegexp":"Le mot de passe doit contenir au moins 8 caractères, une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial.",
      "PasswordMismatch":"Les mots de passe ne correspondent pas",
      "EmailRegexp":"L'adresse email n'est pas valide",
      "EmailAlreadyRegistered":"L'adresse email est déjà utilisée",
      "DataPrivacy": "Veuillez accepter la déclaration de confidentialité",
      "UnknownError":"Une erreur est survenue"
    },
    "DisclaimerSection": {
      "Title": "Disclaimer",
      "DisclaimerShort": "B. Braun Medical AG ne fournit aucune garantie quant au contenu de la page web.",
      "DisclaimerMore": " En aucun cas, B. Braun Medical AG, ses employés, distributeurs, fournisseurs ou sous-traitants ne pourront être tenus responsables de quelque dommage que ce soit, y compris, mais sans s'y limiter, les dommages accidentels, directs, indirects, spéciaux, consécutifs ou punitifs, la perte d'utilisation, la perte de données, la perte de revenus ou de bénéfices, la perte ou les dommages à la propriété, les réclamations de tiers ou d'autres pertes de toute nature."
    }
  },
  "News": {
    "Introduction": "Sous la rubrique Actualités, nous vous informons des nouvelles données relatives aux tests de compatibilité physico-chimique. Vous y trouverez également des informations sur nos solutions de perfusion, nos produits pharmaceutiques et nos solutions de rinçage."
  },
  "ProductCatalog": {
    "Title": "Informations produit",
    "PresentationSection": {
      "Title": "Catalogue des produits",
      "Resume": "B. Braun propose des produits et des solutions pour le traitement par perfusion."
    },
    "Informations": {
      "Title": "Informations produit",
      "Subtitle1": "Les informations essentielles sur le produit, telles que la posologie et l'utilisation, sont disponibles dans l'information professionnelle sur ",
      "Subtitle2": ".",
      "Documentation": "Documentation, matériel d'information",
      "Brochures": {
        "Title": "Classement des différentes brochures",
        "Products": "Survol des produits",
        "Concept": "Concept de perfusion"
      }
    }
  },
  "ProductDetails": {
    "FAQs": "FAQs",
    "Dosage": "Dosage",
    "Documents": "Documentation",
    "Articles": "Articles",
    "Article": {
      "Description": "Description",
      "Reference": "Référence",
      "Pharmacode": "Pharmacode",
      "Quantity": "Quantité",
      "QuantityUnit": "Unités"
    }
  },
  "Compatibility": {
    "Title":"Données de compatibilité",
    "Drug": "Médicament",
    "DisplayBy": "Afficher par",
    "DrugSelection": "Sélection de médicament",
    "TestedMixture": "mélange testé",
    "NotTested": "non testé",
    "Compatible": "compatible",
    "Incompatible": "incompatible",
    "IncompatibleShort": "incompatible",
    "Explanation": "Les indications relatives au rapport de mélange sont données comme suit : 1+1 correspond à un mélange d'une partie de solution porteuse plus une partie de solution médicamenteuse (par ex. 1 ml/minute de Ringerfundin avec 1 ml/minute d'Aequifusin ou encore 2 ml/minute de Ringerfundin avec 2 ml/minute de Calcium Braun 10%, préalablement dilué au 1:11). Une dilution au 1/11 correspond à 1 partie complétée pour un total de 11 parties, par exemple : 1 ml de Calcium Braun 10% ad 11 ml complétés avec du NaCl 0,9%.",
    "ShowAllCompatibilitiesButton":"Montrer toutes les compatibilités",
    "ShowCompatibilitiesButton":"Montrer les compatibilités",
    "NoneSelectedError":"Aucune compatibilité sélectionnée",
    "From": "de",
    "To": "à",
    "mlperminute": "ml/minute",
     "ml": "ml",

    "Introduction": {
      "Title": "Introduction",
      "IntroductionParagraph1": "Les compatibilités énumérées ici font référence à la compatibilité physico-chimique, telle que le changement de pH, le changement de couleur, la turbidité, le changement de taille des particules ou la précipitation.",
      "IntroductionParagraph2": "Les données ne fournissent pas d'informations sur la pharmacocinétique et la pharmacodynamique. Les mélanges indiqués ne constituent pas des recommandations de dosage."
    },
    "CarrierSolutions":{
      "Title":"Solution porteuse"
    },
    "DrugAddition":{
      "Title":"Additifs"
    },
    "SelectDrug":{
      "Title":"Sélection de médicament",
      "TradeNameButton":"Nom",
      "ActiveIngredientButton":"Principe actif",
      "AllButton":"Tous",
      "SelectedMedicinalProducts":"Médicaments choisis"
    },
    "PhysicoChemicalCompatibility":{
      "Title":"Compatibilité physico-chimique",
      "Concentration": "Concentration",
      "SolutionConcentration": "Concentration de substance active dans la solution",
      "MedSolution": "Solution médicamenteuse",
      "MedSolutionConcentration": "Concentration de la solution médicamenteuse",
      "Volume": "Volume du contenant",
      "InContainerParagraph": "Compatibilité physico-chimique de la solution et du médicament dans le contenant.",
      "InLineParagraph": "Compatibilité physico-chimique de la solution et du médicament dans la tubulure (pièce en Y)",

      "CarrierSolution":"Solution porteuse",
      "DrugAdditive":"Médicaments / Additifs",
      "DrugAdditiveTab":{
        "TradeNameAddition":"Nom",
        "ActiveIngredient":"Principe actif",
        "MixingRatio":"Concentration testée de la substance active dans le mélange",
        "TestedIntervals":"Débits de perfusion testés",
        "TestedMix": "Mélanges testés",
        "Compatibility":"Compatibilité",
        "Direct":"Direct",
        "DirectDetails":"4 min en contact",
        "Indirect60":"1h en contact",
        "Indirect24":"24h en contact",
        "After":"Après",
        "Details":"Détails",
        "OpenDetails":"Ouvrir détails",
        "CloseDetails":"Fermer détails",
        "CombinationEvaluation":"Evaluation de la combinaison"
      },
      "Results": {
        "MixDetails": "Détails du mélange",
        "Concentration": "Préparation de la solution médicamenteuse",
        "QuantityFor500": "Quantité pour de solution porteuse",
        "Comments": "Commentaires",
        "PossibleResults": "Résultats possibles",
        "TransportSolutionConcentration": "Concentration de la solution porteuse",
        "SolutionConcentration": "Concentration de la solution",
        "DirectCompat": "Compatibilité directe",
        "AfterCompat": "Compatibilité après 24h"
      },

      "LeitungSlider1": "Vitesse de perfusion dans la solution porteuse (mg/ml)",
      "LeitungSlider2": "Concentration en substance active après dillution / reconstitution",
      "LeitungSlider3": "Vitesse de perfusion dans la solution médicamenteuse (ml/min)",

      "BehaltnisSlider1": "Concentration de la substance active dans la solution médicamenteuse ajoutée (mg/ml)",
      "BehaltnisSlider2": "Volume de la préparation médicamenteuse (ml)"
    },
    "CompatibilityRequest":{
      "Title":"Requête de compatibilité",
      "PresentationSection": {
        "Title": "Demande de test de compatibilité physico-chimique",
        "Resume": "Si vous utilisez fréquemment un médicament qui n'a pas encore été testé, nous pouvons effectuer, après consultation, un test de compatibilité. Utilisez le formulaire ci-dessous pour demander un test."
      },
      "NewRequest": "Médicament non listé ? Demander un nouveau test de compatibilité !",
      "Editor":"Éditeur",
      "LabTester": "Laborantin",

      "CarrierSolution":"Solution porteuse",
      "DrugAdditive":"Médicament / Additif",
      "DrugAdditiveSubText":"Indiquez le nom et le principe actif du médicament",
      "FirstName":"Prénom",
      "LastName":"Nom",
      "SpitalInstitution": "Hopital / Institution",
      "Street":"Rue",
      "PLZ":"Code Postal",
      "Location":"Ville",
      "Country":"Pays",
      "PositionOrFunction":"Position ou fonction",
      "EmailAddress":"Addresse e-mail",
      "Comment":"Remarques",
      "ApplicationDetails": "Détails de l'application",
      "EmptyMedsList": "Veuillez ajouter au moins un médicament",
      "Created": "Votre demande a été transmise avec succès, vous serez contacté prochainement.",
      "Wizard": {
        "NewRequest": "Nouvelle requête",
        "Clarification": "Clarification",
        "AcceptPlan": "Validation du plan",
        "TestPlan": "Phase de test",
        "AcceptResults": "Valider les résultats",
        "Request": "Requête",
        "Requester": "Requester",
        "Date": "Date"
      }
    }
  },
  "Osmolarity": {
    "Title": "Calculateur d'osmolarité",
    "Subtitle": "Solutions de perfusion",
    "Osmolarity": "Osmolarité",
    "Volume": "Volume",
    "Additives": {
      "Title": "Additifs"
    },
    "Solutions": {
      "Title": "Solutions de perfusion"
    },
    "Free": {
      "Title": "Entrée variable",
      "Name": "Nom :",
      "Osmolarity": "Osmolarité :",
      "Volume": "Volume :",
      "Description": "Indiquez une osmolarité et un volume."
    },

    "Introduction": {
      "Title": "Introduction",
      "P1": "Calculer l'osmolarité d'une solution de perfusion contenant un ou plusieurs additifs de perfusion.",
      "P2": "En cas d'administration d'une solution supérieure à 900 mosm/l, il est préférable de procéder à une administration par voie veineuse centrale afin de minimiser le risque de phlébite. En pédiatrie, il convient d'envisager l'administration par voie veineuse centrale d'une solution pour perfusion dont l'osmolarité est supérieure à 500 mosm/l.",
      "P3": "Le calculateur d'osmolarité ne permet pas, d'une part, de vérifier la justesse thérapeutique (pas de recommandation de dosage ni d'utilisation) et, d'autre part, de vérifier la compatibilité physico-chimique des composants."
    },
    "SelectInfusionSolution":{
      "Title":"Choix de la solution de perfusion"
    },
    "EnterTheInfusionSolutionVolume":{
      "Title":"Volume de la solution de perfusion"
    },
    "SelectInfusionAdditives":{
      "Title":"Choix des additifs"
    },
    "EnterVolumeForInfusionAdditives":{
      "Title":"Volume des additifs"
    },
    "Result":{
      "Title":"Résultats",
      "InfusionSolution":"Solution de perfusion",
      "InfusionAdditives":"Additifs perfusables",
      "TotalVolume":"Volume total du mélange (ml)",
      "OsmolarityOfTheMixture":"Osmolarité du mélange (mosm/l)",
      "Warning": {
        "below500": "Administration par voie veineuse périphérique ou centrale possible",
        "between500And800": "Envisager l'administration par voie veineuse centrale",
        "above800": "Administration par voie veineuse centrale recommandée"
      },
      "Ingredients":"Composition du mélange",
      "Absolutely":"Absolu*",
      "Relative":"Relatif**",
      "AbsolutelyDescription":"*Absolument : les indications se réfèrent à la solution totale que vous avez choisie",
      "RelativeDescription":"**Relatif : les données se réfèrent à un litre",
      "AdditionalInfo":"Pour des informations détaillées, veuillez consulter l'information professionelle (voir la notice d'emballage ou www.swissmedicinfo.ch)."
    }
  },
  "SearchPage": {
    "Items": {
      "Any": "éléments",
      "All": "Tous",
      "For": "pour",
      "Found": "trouvé(s)",
      "Products": "Produits uniquement",
      "News": "News uniquement",
      "FAQ": "FAQ uniquement"
    },
    "Types": {
      "product": "Produit",
      "news": "New",
      "faq": "FAQ"
    },
    "Research": "Recherche :",
    "More": "Voir plus"
  },
  "Requester": {
    "RejectionReason": "Raison du refus",
    "Close": "Fermer",
    "Send": "Envoyer"
  },
  "Privacy": {
    "Title": "Protection des données"
  }
}
